let fontsize;

document.addEventListener('click', event => {
  if (event.target.closest('[data-fontsize]')) {
    const fontsize = window.sessionStorage.getItem('fontsize') || '';

    if (fontsize === 'high') {
      window.sessionStorage.removeItem('fontsize');
      document.body.classList.remove('large-fontsize');
    } else {
      window.sessionStorage.setItem('fontsize', 'high');
      document.body.classList.add('large-fontsize');
    }
  }
});

document.addEventListener("DOMContentLoaded", () => {
  // Füge den Eventlistener für jeden Button hinzu
  const buttons = document.querySelectorAll(".js-toggle-subpages");
  buttons.forEach(button => {
    button.addEventListener("click", function () {
      this.classList.toggle('active');
      const nextElement = this.nextElementSibling; // Nächstes Element auswählen
      nextElement.classList.toggle('active');
    });
  });
});

export default fontsize;